import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  /* Card wrapping search component */
  & > *:first-child {
    flex: 2 0 0;
  }

  /* Card wrapping create button */
  & > *:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    flex: 1;
    margin-top: 15px;
  }

  ${({ theme }) => theme.media.bigDesktopUp`
    flex-direction: row;

    & > *:last-child {
      margin-top: 0;
      margin-left: 15px;
    }
  `}
`;
// Lays out the date picker with its clear button on one row
export const DatePickerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  /* The date picker shrinks to make room for the clear button */
  & > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

export const ClearDatesButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 8px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  /* White-label text colour, falling back for legacy themes without one */
  color: ${({ theme }) => (theme.brand && theme.brand.text) || '#555'};
  cursor: pointer;

  /* react-feather's currentColor default is via defaultProps, which React 19
     no longer applies to function components — set the stroke ourselves */
  & svg {
    stroke: currentColor;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

// Date selection and action buttons are grouped together in a flex box within the header flex box
export const DateAndButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  & > *:last-child {
    margin-top: 15px;
  }
  ${({ theme }) => theme.media.tabletLandscapeUp`
    flex-direction: row;
    min-width: 50em;
    & > *:first-child {
      flex: 2;
    }

    & > *:last-child {
      flex: 1;
      margin-left: 15px;
      margin-top: 0px;
    }
  
  `}
`;
